import React, { useEffect, useState } from 'react'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import Select from 'react-select'
import Switch from 'react-switch'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from 'views/shared/useFormUtils'
import PropTypes from 'prop-types'
import { fatLevelOptions, flavorOptions } from './constants'
import { isNotAlpha } from 'context/Utilities'

const YogurtPackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    FatLevel: item.FatLevel,
    Flavor: item.Flavor,
    OtherFlavor: item.OtherFlavor,
    Size: item.Size,
    MultiPackageType: item.MultiPackageType,
    MultiPackageCount: item.MultiPackageCount,
  })
  const methods = useFormContext()
  const {
    onChangeReviewer,
    setSwitchReviewer,
    setSelectReviewer,
    asterisk,
  } = useFormUtils()
  useEffect(() => {
    if (item) {
      const {
        FatLevel,
        Flavor,
        OtherFlavor,
        Size,
        MultiPackageType,
        MultiPackageCount,
      } = item
      setPackaging({
        FatLevel,
        Flavor,
        OtherFlavor,
        Size,
        MultiPackageType,
        MultiPackageCount,
      })
    }
    // eslint-disable-next-line
  }, [item])

  return (
    <Row>
      <Col xs={6}>
        <FormGroup>
          <p>
            <strong>Fat Level {asterisk}</strong>
          </p>
          <Controller
            as={Select}
            className="react-select primary"
            classNamePrefix="react-select"
            options={fatLevelOptions}
            defaultValue={{
              label: packaging.FatLevel,
              value: packaging.FatLevel,
            }}
            name="FatLevel"
            control={methods.control}
            rules={{ required: true }}
            placeholder={'Select Yogurt Fat Level'}
            onChange={([selected, value]) => {
              setSelectReviewer(item, selected, value)
              return selected
            }}
            isDisabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="FatLevel"
              message={'⚠ Please select a Fat Level.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
        <br />
        <FormGroup>
          <p>
            <strong>Flavor {asterisk}</strong>
          </p>
          <Controller
            as={Select}
            className="react-select primary"
            classNamePrefix="react-select"
            options={flavorOptions}
            defaultValue={{
              label: packaging.Flavor,
              value: packaging.Flavor,
            }}
            name="Flavor"
            control={methods.control}
            rules={{ required: true }}
            placeholder={'Select Flavor'}
            onChange={([selected, value]) => {
              setSelectReviewer(item, selected, value)
              setPackaging({
                ...packaging,
                Flavor: value,
              })
              return selected
            }}
            isDisabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="FatLevel"
              message={'⚠ Please select a flavor.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
        <br />
        {item?.Flavor === 'Other Fruit Flavor' && (
          <FormGroup>
            <p>
              <strong>Other Fruit Flavor (Please Specify) {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="OtherFlavor"
              placeholder={'Other Fruit Flavor'}
              defaultValue={item.OtherFlavor}
              control={methods.control}
              rules={{
                required: true,
                maxLength: {
                  value: 30,
                  message: '⚠ Other Fruit Flavor exceeds 30 characters.',
                },
              }}
              onKeyDown={e => {
                if (isNotAlpha(e.key) && e.key !== ' ') {
                  e.preventDefault()
                }
              }}
              onChange={([event]) => {
                onChangeReviewer(item, event)
                return event
              }}
              disabled={isDisabled}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="OtherFlavor"
                message={'Other Fruit Flavor is required.'}
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        )}
        <br />
        <FormGroup>
          <p>
            <strong>Size {asterisk}</strong>
          </p>
          <Input defaultValue={packaging.Size} disabled />
        </FormGroup>
      </Col>
      <Col xs={6}>
        <FormGroup>
          <p>
            <strong>Multi-pack</strong>
          </p>
          <Controller
            as={Switch}
            name="MultiPackageType"
            id="MultiPackageType"
            onChange={([checked, event, id]) => {
              setSwitchReviewer(item, checked, event, id)
              setPackaging({
                ...packaging,
                MultiPackageType: checked,
              })
              return checked
            }}
            control={methods.control}
            defaultValue={packaging.MultiPackageType}
            disabled={isDisabled}
          />
          <br />
          <br />
          <br />
          {packaging.MultiPackageType === true && (
            <FormGroup>
              <p>
                <strong>Multi-pack Count {asterisk}</strong>
              </p>
              <Controller
                as={Input}
                name="MultiPackageCount"
                placeholder={'Multi-pack Count'}
                defaultValue={packaging.MultiPackageCount}
                onKeyDown={e => {
                  if (
                    ![
                      'Backspace',
                      'Delete',
                      'Tab',
                      'ArrowLeft',
                      'ArrowRight',
                    ].includes(e.key) &&
                    isNaN(parseInt(e.key))
                  ) {
                    e.preventDefault()
                  }
                }}
                control={methods.control}
                rules={{
                  maxLength: { value: 2, message: '⚠ 2 characters max.' },
                  required: {
                    value: true,
                    message: '⚠ Multi Pack Count is required.',
                  },
                }}
                onChange={([event]) => {
                  onChangeReviewer(item, event)
                  return event
                }}
                disabled={isDisabled}
              />
              <p className={'text-danger'}>
                <ErrorMessage
                  errors={methods.errors}
                  name="MultiPackageCount"
                  as={<Alert color={'danger'} className={'mt-3'} />}
                />
              </p>
            </FormGroup>
          )}
        </FormGroup>
      </Col>
    </Row>
  )
}

YogurtPackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default YogurtPackageReview
